/**
 * Labstep
 *
 * @module screens/ResourceItem/Show/Center
 * @desc ResourceItem Show Center
 */

import { EntityPrimaryInfoImage } from 'labstep-web/components/Entity/PrimaryInfo/Image';
import { EntityUserCard } from 'labstep-web/components/EntityUser/Card';
import {
  Action,
  ResourceItemActionMenu,
} from 'labstep-web/components/ResourceItem/Action/Menu';
import { ResourceItemBreadcrumb } from 'labstep-web/components/ResourceItem/Breadcrumb';
import { InformationCard } from 'labstep-web/core/Card/Information';
import { ResourceItemShowCenterContentSecondaryInfo } from 'labstep-web/screens/ResourceItem/Show/Center/SecondaryInfo';
import type React from 'react';
import styles from './styles.module.scss';
import type { ICenterProps } from './types';

export const Center: React.FC<ICenterProps> = ({ resourceItem }) => (
  <div id="resource-item-show-screen" className={styles.container}>
    <InformationCard
      additionalActions={<EntityUserCard entity={resourceItem} />}
      actionMenu={
        <ResourceItemActionMenu
          resourceItem={resourceItem}
          actions={[Action.delete, Action.duplicate]}
        />
      }
      breadcrumb={
        <ResourceItemBreadcrumb resourceItem={resourceItem} />
      }
      primaryInfo={<EntityPrimaryInfoImage entity={resourceItem} />}
      secondaryInfo={
        <ResourceItemShowCenterContentSecondaryInfo
          resourceItem={resourceItem}
        />
      }
    />
  </div>
);
